import React from 'react';

export function Checked ({opacity = 1}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      opacity={opacity}
    >
      <rect
        width="19"
        height="19"
        x="0.5"
        y="0.5"
        stroke="#919191"
        rx="3.5"
      />
      <rect width="20" height="20" fill="#4FADA6" rx="4" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.25 10.278L8.558 12.5l5.192-5"
      />
    </svg>
  );
}
